import { Sparkles } from 'lucide-react';

interface Props {
  title: string;
  hint?: string;
}

/**
 * Placeholder destination for sidebar entries whose dedicated screen
 * hasn't landed yet. Subsequent agents (5, 7, …) replace these route
 * elements with real pages.
 */
export function PlaceholderPage({ title, hint }: Props) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div
        className="ed-card max-w-[520px] text-center"
        style={{ padding: '2.25rem 2rem' }}
      >
        <div
          className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-lg"
          style={{ background: 'var(--bg-sunken)', color: 'var(--fg-low)' }}
        >
          <Sparkles className="h-4 w-4" strokeWidth={1.75} />
        </div>
        <div className="ed-eyebrow mb-2">Coming Soon</div>
        <h2
          className="text-[22px] font-semibold tracking-[-0.02em] mb-2"
          style={{ color: 'var(--fg-high)' }}
        >
          {title}
        </h2>
        <p className="text-[13px]" style={{ color: 'var(--fg-low)' }}>
          {hint ?? 'This screen is on the build queue.'}
        </p>
      </div>
    </div>
  );
}
